<template>
  <label class="flex shrink-0 cursor-pointer items-center">
    <input type="checkbox" class="sr-only" :checked="modelValue" @change="toggle" />
    <span
      class="flex size-5 items-center justify-center rounded-md border transition-colors"
      :class="modelValue ? 'border-primary bg-primary' : 'border-primary/20 bg-white'"
    >
      <Icon v-if="modelValue" name="lucide:check" class="size-3.5 text-white" />
    </span>
  </label>
</template>

<script setup lang="ts">
  const props = defineProps<{ modelValue?: boolean }>();
  const emit = defineEmits<{ "update:modelValue": [value: boolean] }>();

  const toggle = () => emit("update:modelValue", !props.modelValue);
</script>
